/* Atalhos de DOM. */

export function $<T extends HTMLElement = HTMLElement>(seletor: string): T {
  const el = document.querySelector<T>(seletor);
  if (!el) throw new Error(`Elemento não encontrado: ${seletor}`);
  return el;
}

export const setHtml = (id: string, html: string): void => {
  const el = document.getElementById(id);
  if (el) el.innerHTML = html;
};

/** Ícone do sprite SVG do index.html. */
export const ic = (nome: string, estilo = ''): string => `<svg${estilo ? ` style="${estilo}"` : ''}><use href="#${nome}"/></svg>`;

/** Valor de um campo de formulário pelo id (vazio se não existir). */
export const valorDe = (id: string): string =>
  (document.getElementById(id) as HTMLInputElement | HTMLSelectElement | null)?.value.trim() ?? '';
